import theme from "assets/theme";
import React from "react";
import { StyleSheet, View } from "react-native";

const classes = StyleSheet.create({
  root: {
    flexDirection: "row",
    alignItems: "flex-end",
    boxShadow: theme.shadow.bottomElevation2,
    borderRadius: 3,
    zIndex: 10, // ensure layered on top
  },
});

export default function Banner(props) {
  const { children } = props;

  return <View style={[classes.root, props.classes]}>{children}</View>;
}
